import React, {
  Component
} from 'react'
import {
  NavBar,
  List,
  Toast
} from 'antd-mobile'
import {
  ROOT_PATH
} from '../../config';
import Table from '../../components/Table'
import df from 'dateformat';
import send from '../../utils/send';

export default class NpDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          id: 'col1',
          title: '项目', //表头信息
          fixed: true, //是否为固定表头
          width: 145, //设置固定宽度
          align: 'left' //文本对齐方式 left center right
        },
        {
          id: 'col2',
          title: '期初',
          align: 'right'
        },
        {
          id: 'col3',
          title: '采购',
          align: 'right'
        },
        {
          id: 'col4',
          title: '转入',
          align: 'right'
        },
        {
          id: 'col5',
          title: '转出',
          align: 'right'
        },
        {
          id: 'col6',
          title: '销售',
          align: 'right'
        },
        {
          id: 'col7',
          title: '死亡',
          align: 'right'
        },
        {
          id: 'col8',
          title: '淘汰',
          align: 'right'
        },
        {
          id: 'col9',
          title: '期末',
          align: 'right'
        }
      ],
      details: [
      ],
      details1: [
        {
        col1: '数据11',
        col2: '数据12',
        col3: '数据13',
        col4: '数据14'
      }
      ],  // 筛选后结果
      datas: []    // 原结果
    }
  }
  getDetail = (data) => {
    Toast.loading('加载中',0);
    const {date} = this.state;
    let d = df(date, 'yyyy-mm-dd');
    send(`${ROOT_PATH}/api/forward/ifarm/location-detail`, {
      method: 'POST',
      data: {
        'startDate': d,
        'endDate': d,
        'dateToday': d,
        'gdType': ['D000201'],
        'gdCode': ['1003'],
        'command': 'getCommand2',
        'paraClickValue1': data,
        'datasFlag': '2'
      }
    })
      .then(res => {
        Toast.hide();
        let datas = [];
        res.data.map((item) => {
          datas.push({
            col1: item.FARM_ORG,
            col2: item.BF,
            col3: item.PURCHASE,
            col4: item.TRN_IN,
            col5: item.TRN_OUT,
            col6: item.SALE,
            col7: item.DEAD,
            col8: item.CULL,
            col9: item.CF
          })
        });
        this.setState({details: datas, datas})
      })
  };
  componentDidMount() {
    this.getDetail(this.props.data);
  }
  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavBar mode="light">猪只存栏信息</NavBar>
        <List
            style={{
                height: document.documentElement.clientHeight - 48,
                overflowY: 'scroll'
              }}
        >
          <Table columns={this.state.columns}
              data={this.state.details}
          />
        </List>
      </React.Fragment>
    )
  }
}
